import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { User, AuthState } from "../model/authTypes";
// import { RootState } from "@/app/store";
// import { useSelector } from "react-redux";

const initialState: AuthState = {
  user: null,
  isAuthenticated: false,
  isLoading: false,
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<User>) => {
      state.user = action.payload;
      state.isAuthenticated = true;
    },
    clearUser: (state) => {
      state.user = null;
      state.isAuthenticated = false;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
  },
});

export const { setUser, clearUser, setLoading } = authSlice.actions;
// export const useAuth = () => useSelector((state: RootState) => state.auth.user);
// export const useIsAuthenticated = () => useSelector((state: RootState) => state.auth.isAuthenticated);
export default authSlice.reducer;
